import share from '@/lib/share';

export default {
	/**
	 * @description: 关闭全局弹窗
	 */

	closeModal() {
		this.$store.dispatch('closeModal');
	},

	/**
	 * @description: 打开限时任务弹窗一
	 * @param {Object} task - 限时任务配置
	 */

	openLimitModalOne(task, page_title = '福利任务页') {
		this.trackClick({
			page_title,
			element_name: '「限时现金奖励」弹窗',
		});
		const { amount: reward, title, desc, info, img } = task;
		console.log('限时任务数据： task =>', task);

		this.$store.dispatch('openModal', {
			modalType: 'limit-reward',
			pos: {
				right: 10,
			},
			btnFn: () => {
				this.trackClick({
					page_title,
					element_name: '「限时现金奖励」弹窗button-开心领取现金',
				});
				this.closeModal();
				this.startLimitBtnClick({
					reward,
				});
			},
			closeFn: () => {
				this.trackClick({
					page_title,
					element_name: '「限时现金奖励」弹窗button-放弃现金',
				});
				this.closeModal();
				this.openLimitKeepModalOne({
					reward,
				});
			},
			props: {
				reward,
				title,
				desc,
				info,
				imgs: img,
			},
		});
	},

	/**
	 * @description: 打开限时任务弹窗二
	 * @param {Number} reward - 任务奖励金额
	 */

	openLimitModalTwo({ reward }) {
		this.trackClick({
			page_title: '福利任务页',
			element_name: '「成功到账」弹窗',
		});
		const { avatar } = this.$store.getters.client;

		this.$store.dispatch('openModal', {
			modalType: 'limit-reward-2',
			pos: {
				right: 0.6,
			},
			btnFn: () => {
				this.trackClick({
					page_title: '福利任务页',
					element_name: '「成功到账」弹窗button-分享好友立即提现',
				});
				share.weixin({ sharePosition: 'limit_task' });
				// 用户点击分享后自动关闭当前弹窗结束此流程
				this.closeModal();
			},
			closeFn: () => {
				this.openLimitKeepModalTwo(reward);
			},
			props: {
				reward,
				avatar,
			},
		});
	},

	/**
	 * @description: 打开限时任务挽留弹窗一
	 * @param {Number} reward - 任务奖励金额
	 */

	openLimitKeepModalOne({ reward }) {
		this.trackClick({
			page_title: '福利任务页',
			element_name: '「挽留」弹窗',
		});

		this.$store.dispatch('openModal', {
			modalType: 'first-retain',
			pos: {
				right: 0,
			},
			btnFn: () => {
				this.trackClick({
					page_title: '福利任务页',
					element_name: '「挽留」弹窗button-继续开心领现金',
				});
				this.closeModal();
				this.startLimitBtnClick({
					reward,
				});
			},
			closeFn: () => {
				this.closeModal();
				this.trackClick({
					page_title: '福利任务页',
					element_name: '「挽留」弹窗button-放弃现金',
				});
			},
			props: {
				reward,
			},
		});
	},

	/**
	 * @description: 打开限时任务挽留弹窗二
	 * @param {Number} reward - 任务奖励金额
	 */

	openLimitKeepModalTwo(reward) {
		this.trackClick({
			page_title: '福利任务页',
			element_name: '「现金到账挽留」弹窗',
		});

		this.$store.dispatch('openModal', {
			modalType: 'second-retain',
			pos: {
				right: 0,
			},
			btnFn: () => {
				share.weixin({ sharePosition: 'limit_task' });
				// 用户点击分享后自动关闭当前弹窗结束此流程
				this.closeModal();
				this.trackClick({
					page_title: '福利任务页',
					element_name: '「现金到账挽留」弹窗button-分享好友继续领现金',
				});
			},
			closeFn: () => {
				this.closeModal();
				this.trackClick({
					page_title: '福利任务页',
					element_name: '「现金到账挽留」弹窗button-放弃现金',
				});
			},
			props: {
				reward,
			},
		});
	},

	/**
	 * @description: 打开限时任务成功弹窗
	 * @param {Object} successInfo - 限时任务成功弹窗信息
	 */

	openLimitSuccessModal(successInfo, page_title = '福利任务页') {
		this.trackClick({
			page_title,
			element_name: '「恭喜发财成功邀请」弹窗',
		});
		const {
			amount: reward,
			reward_show: rewardTxt,
			img: [avatar],
			title,
			desc,
			info,
			remain_num: remainNum,
		} = successInfo;

		this.$store.dispatch('openModal', {
			modalType: 'limit-reward-success',
			pos: {
				right: 0.6,
			},
			btnFn: () => {
				this.trackClick({
					page_title,
					element_name: '「恭喜发财成功邀请」弹窗button-明白继续领现金',
				});
				this.closeModal();
				const modalConf_remain_num = remainNum || this.$store.getters['welfare/task/modalConf'].remain_num;

				if (!modalConf_remain_num) {
					return;
				}

				this.startLimitBtnClick({
					reward,
				});
			},
			closeFn: () => {
				this.closeModal();
				this.trackClick({
					page_title,
					element_name: '「恭喜发财成功邀请」弹窗button-x',
				});
			},
			props: {
				rewardTxt,
				avatar,
				title,
				desc,
				info,
				remainNum,
			},
		});
	},

	/**
	 * @description: 打开限时任务失败弹窗
	 * @param {Object} failInfo - 限时任务失败弹窗信息
	 */

	openLimitFailModal(failInfo, page_title = '福利任务页') {
		this.trackClick({
			page_title,
			element_name: '「很遗憾」弹窗',
		});
		const { amount: reward, remain_num: remainNum } = failInfo;

		this.$store.dispatch('openModal', {
			modalType: 'limit-reward-fail',
			pos: {
				right: 0.6,
			},
			btnFn: () => {
				this.trackClick('「很遗憾」弹窗button-明白继续领现金');
				this.closeModal();
				const modalConf_remain_num = remainNum || this.$store.getters['welfare/task/modalConf'].remain_num;

				if (!modalConf_remain_num) {
					return;
				}
				this.startLimitBtnClick({
					reward,
				});
			},
			closeFn: () => {
				this.closeModal();
			},
			props: {
				remainNum,
			},
		});
	},

	/**
	 * @description: 开启限时任务功能按钮点击方法
	 * @param {Number} reward - 任务奖金
	 * @param {String} avatar - 用户头像
	 */

	startLimitBtnClick({ reward }) {
		// 开启限时任务
		this.startLimitTask();
		this.$post(this.$api.GET_LIMIT_TASK_BONUS).then((res) => {
			// 打开限时任务弹窗二
			this.openLimitModalTwo({
				reward: res.data.amount,
			});
		});
	},

	/**
	 * @description 首邀弹窗
	 * @param {Object} data
	 * @param {String} page_title
	 */
	openFirstInviteModal({ reward_amount }, page_title) {
		this.$store.dispatch('openModal', {
			modalType: 'first-invite-modal',
			pos: {
				right: 0,
			},
			btnFn: () => {
				share.weixin({ sharePosition: 'first_invite' });
				this.trackClick({
					page_title,
					element_name: '首邀奖励弹窗',
					remarks: '立即邀请',
				});
				// 用户点击分享后自动关闭当前弹窗结束此流程
				this.closeModal();
			},
			closeFn: () => {
				this.closeModal();
				this.trackClick({
					page_title,
					element_name: '首邀奖励弹窗',
					remarks: '关闭',
				});
			},
			props: {
				priceNum: reward_amount / 100 || 0,
			},
		});
	},
	/**
	 * @description 首邀弹窗
	 * @param {Object} data
	 * @param {String} page_title
	 */

	openFirstInviteSuccessModal({ reward_amount }, page_title) {
		this.$store.dispatch('openModal', {
			modalType: 'first-invite-success-modal',
			pos: {
				right: 0,
			},
			btnFn: () => {
				this.trackClick({
					page_title,
					element_name: '首邀奖励获得弹窗',
					remarks: '再赚8元',
				});
				this.closeModal();
			},
			closeFn: () => {
				this.closeModal();
				this.trackClick({
					page_title,
					element_name: '首邀奖励获得弹窗',
					remarks: '关闭',
				});
			},
			props: {
				priceNum: reward_amount / 100 || 0,
			},
		});
	},
	/**
	 * @description 首邀2.0弹窗
	 * @param { Object } data
	 * @param { string } page_title
	 */
	openFirstInviteRedBagModal(data, page_title) {
		this.$store.dispatch('openModal', {
			modalType: 'red-bag-need-open-modal',
			pos: {
				right: 0.5,
			},
			btnFn: () => {
				this.trackClick({
					page_title,
					element_name: '开',
					remarks: '首邀红包',
				});
				this.closeModal();
				this.$post(this.$api.OPEN_FIRST_INVITE_TASK).then((res) => {
					if (res.code === '0') {
						// 打开弹窗二
						this.openFirstInviteOnGoingModal({}, '长期裂变页');
						this.$store.commit('fission/setFirstInviteCountDownShow', 1);
					}
				});
			},
			closeFn: () => {
				this.closeModal();
				this.trackClick({
					page_title,
					element_name: '关',
					remarks: '首邀红包',
				});
			},
		});
	},
	/**
	 * @description 首邀进行中
	 * @param { Object } data
	 * @param { string } page_title
	 */
	openFirstInviteOnGoingModal(data, page_title) {
		this.$store.dispatch('openModal', {
			modalType: 'first-invite-ongoing-modal',
			pos: {
				right: 0.5,
			},
			btnFn: () => {
				share.weixin({ sharePosition: 'first_invite' });
				let firstInviteByDay = this.$store.getters['fission/firstInviteByDay'];
				this.trackClick({
					page_title,
					element_name: firstInviteByDay.button_open_text,
					remarks: '首邀进行中弹窗',
				});
				this.closeModal();
			},
			closeFn: () => {
				this.closeModal();
				this.trackClick({
					page_title,
					element_name: '首邀关',
					remarks: '首邀进行中弹窗',
				});
			},
		});
	},
	/**
	 * @description 首邀2.0成功
	 * @param { Object } data
	 * @param { string } page_title
	 */
	openFirstInviteSuccess2Modal(data, page_title) {
		this.$store.dispatch('openModal', {
			modalType: 'first-invite-success-modal2',
			pos: {
				right: 0.5,
			},
			btnFn: () => {
				share.weixin({ sharePosition: 'first_invite' });
				let firstInviteByDay = this.$store.getters['fission/firstInviteByDay'];
				this.trackClick({
					page_title,
					element_name: firstInviteByDay.button_success_text,
					remarks: '首邀成功弹窗',
				});
				this.closeModal();
			},
			closeFn: () => {
				this.closeModal();
				this.trackClick({
					page_title,
					element_name: '成功关',
					remarks: '首邀成功弹窗',
				});
			},
		});
	},

	/**
	 * @description 金币汇率进行中弹窗
	 * @param { Object } data
	 * @param { string } page_title
	 */

	openIconsRateOnGoingModal(data, page_title) {
		this.trackClick({
			page_title,
			element_name: '任务弹窗',
			remarks: '金币汇率任务弹窗',
		});
		this.$store.dispatch('openModal', {
			modalType: 'icons_rate_ongoing_modal',
			pos: {
				right: 1.5,
				top: 2.5,
			},
			btnFn: () => {
				this.trackClick({
					page_title,
					element_name: '去邀请',
					remarks: '金币汇率提升开启弹窗',
				});
				share.weixin({ sharePosition: 'icons_rate' });
				this.closeModal();
			},
			closeFn: () => {
				this.closeModal();
				this.trackClick({
					page_title,
					element_name: '关',
					remarks: '金币汇率提升开启弹窗',
				});
			},
			props: {
				windowData: data.window_data,
			},
		});
	},
	/**
	 * @description 金币汇率提升成功弹窗
	 * @param { Object } data
	 * @param { string } page_title
	 */

	openIconsRateSuccessModal(data, page_title) {
		this.trackClick({
			page_title,
			element_name: '汇率弹窗',
			remarks: '金币汇率提升成功弹窗',
		});
		this.$store.dispatch('openModal', {
			modalType: 'icons_rate_success_modal',
			pos: {
				value: 'hiddenModalClose',
			},
			btnFn: () => {
				this.trackClick({
					page_title: '汇率弹窗',
					element_name: '分享',
					remarks: '金币汇率提升成功弹窗',
				});
				share.weixin({ sharePosition: 'icons_rate' });
				// 获取分享奖励
				this.$post(this.$api.GET_ICONS_RATE_SHARE_REWARD, { fission_id: data.window_data.fission_id });
				this.closeModal();
			},
			props: {
				windowData: data.window_data,
			},
		});
	},
	/**
	 * @description 金币汇率分享成功弹窗
	 * @param { Object } data
	 * @param { string } page_title
	 */
	openIconsRateShareSuccessModal(data, page_title) {
		this.trackClick({
			page_title,
			element_name: '赢家弹窗',
			remarks: '金币汇率赢家弹窗',
		});
		this.$store.dispatch('openModal', {
			modalType: 'icons_rate_share_success_modal',
			pos: {
				top: -0.4,
			},
			props: {
				windowData: data.window_data,
			},
		});
	},
	/**
	 * @description 金币汇率遗憾弹窗
	 * @param { Object } data
	 * @param { string } page_title
	 */
	openIconsRateRegretModal(data, page_title) {
		this.trackClick({
			page_title,
			element_name: '遗憾弹窗',
			remarks: '金币汇率遗憾弹窗',
		});
		this.$store.dispatch('openModal', {
			modalType: 'icons_rate_regret_modal',
			pos: {
				top: -0.4,
			},
			btnFn: () => {
				this.trackClick({
					page_title,
					element_name: '再试一次',
					remarks: '金币汇率提升失败弹窗',
				});
				this.closeModal();
				this.$post(this.$api.OPEN_ICONS_RATE_TASK, {}).then((res) => {
					if (res.code === '0') {
						this.openIconsRateOnGoingModal({ window_data: res.data }, page_title);
					}
				});
			},
			props: {
				windowData: data.window_data,
			},
		});
	},

	/**
	 * @description 打开双人打卡活动入口弹窗
	 * @param { Object } data 弹窗数据
	 */

	openDoubleSignEntryModal(data) {
		const { link } = data;

		this.$store.dispatch('openModal', {
			modalType: 'doubleSignInEntry',
			pos: { value: 'bottom' },
			btnFn: () => {
				this.$sdkNew.appCall('OPEN_PAGE_WITH_JSON', JSON.stringify({ url: link }));

				// 埋点
				this.trackClick({
					page_title: '福利任务',
					element_name: '立即参加',
				});
			},
		});
	},
};



// WEBPACK FOOTER //
// ./src/root/handleModal.js